import React from 'react';
import './Projects.css';
import { FaReact, FaHardHat } from 'react-icons/fa';
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs,
  SiCss3,
} from 'react-icons/si';
import { DiCss3 } from 'react-icons/di';
import { VscJson } from 'react-icons/vsc';
import { IoLogoJavascript } from 'react-icons/io';
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/flexor.png" alt="Buson image" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Flexor Replica</h2>
              <p>
                Clone of the popular multipage and fully responsive Flexor
                website. Built by using HTML5, CSS3.
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
              </div>
              <div>
                <a
                  href="https://atul1104.github.io/Checkpoint-4/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/Checkpoint-3.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/url-shortner.png" alt="Url-shortner" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Url Shortner</h2>
              <p>
                URL shortner app developed in React. Wherein the hooks are used
                e.g. state hooks such as useState and useEffect.
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <IoLogoJavascript />
                <FaReact />
              </div>
              <div>
                <a
                  href="https://url-shortner-react-app.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/url-shortner-react"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/dictionary.png" alt="" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Simple Dictionary App</h2>
              <p>
                Developed Simple Dictionary where you can search meaning,
                examples, synonyms and antonyms of any word. This app is created
                by fetching API and using state hooks.
              </p>
              <div>
                <SiHtml5 />
                <SiCss3 />
                <IoLogoJavascript />
                <FaReact />
              </div>
              <div>
                <a
                  href="https://simple-dictionary-app.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See the live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/simple-dictionary-react"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/crypto-app.png" alt="Crypto-app" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Coin Search App</h2>
              <p>
                Mini project of Coin Search built using ReactJS. Features :
                Gives real time market cap, price etc and detailed information
                about every crypto coins.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://mellifluous-strudel-4afa59.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/crypto-app-react"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/grocery-bud.png" alt="grocery-bud" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Grocery Bud</h2>
              <p>
                Developed Grocery Bud App usind React where you can perform CRUD
                operations.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://kaleidoscopic-sprite-21c6d2.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/Grocery-app-react"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img src="/assets/T-analyzer.png" alt="Text-analyzer" />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Text Analyzer</h2>
              <p>
                Developed Text Analyzer App usind React where you can make text
                uppercase, lowercase, count the words, analyse the time to read
                the text. This app has dark and light mode toggle switch.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://t-analyzer.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/atul1104/text-analyzer-react"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
